import axios from 'axios';
import { ChamberMemberCodebookModel, CodebookModel } from 'app/shared/model/shared.model';
import { PublicAuthorityCodebook } from 'app/edozvola/cases/special-regulations-compliance/model/special-regulations-compliance.model';

const codebookBaseUrl = '/api/codebooks';

export const fetchCaseCategoryCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-category`).then(response => resolve(response.data));
  });
};

export const fetchRetentionPeriodCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/retention-period`).then(response => resolve(response.data));
  });
};

export const fetchSubjectTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/subject-type`).then(response => resolve(response.data));
  });
};

export const fetchSubjectTypeForCaseSubmission = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/subject-type-case-submission`).then(response => resolve(response.data));
  });
};

export const fetchBuildingTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/building-type`).then(response => resolve(response.data));
  });
};

export const fetchAttachmentTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/attachment-type`).then(response => resolve(response.data));
  });
};

export const fetchArrangementAccessCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/arrangement-access`).then(response => resolve(response.data));
  });
};

export const fetchArrangementDrainageCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/arrangement-drainage`).then(response => resolve(response.data));
  });
};

export const fetchArrangementElectricityCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/arrangement-electricity`).then(response => resolve(response.data));
  });
};

export const fetchProjectEngineerStatementCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/p-engineer-statement`).then(response => resolve(response.data));
  });
};

export const fetchCaseCategoryForCase = async (idCase: string): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-category/case/${idCase}`).then(response => resolve(response.data));
  });
};

export const fetchRequestAttachmentsForCaseCategory = async (idCase: string): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/request-attachments-for-case/${idCase}`).then(result => resolve(result.data));
  });
};

export const fetchAuthorityCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/authority`).then(response => resolve(response.data));
  });
};

export const fetchAdministrativeUnitCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/administrative-unit`).then(response => resolve(response.data));
  });
};

export const fetchAdministrativeUnitForAuthority = async (authority): Promise<any> => {
  return await new Promise(resolve => {
    axios.post(`${codebookBaseUrl}/administrative-unit/authority`, authority).then(response => resolve(response.data));
  });
};

export const fetchCosolverForCase = async (idCase: string): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cosolver/case/${idCase}`).then(response => resolve(response.data));
  });
};

export const fetchSolverForCase = async (idCase: string): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/solver/case/${idCase}`).then(response => resolve(response.data));
  });
};

export const fetchRequestAmendmentCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/request-amendment`).then(response => resolve(response.data));
  });
};

export const fetchNumberOfDaysToSolveCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/number-of-days-to-solve`).then(response => resolve(response.data));
  });
};

export const fetchGeneralTariffCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/general-tariff`).then(response => resolve(response.data));
  });
};

export const fetchLegalRemedyCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/legal-remedy`).then(response => resolve(response.data));
  });
};

export const fetchProcurationTypes = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/procuration-type`).then(response => resolve(response.data));
  });
};

export const fetchCountries = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/country`).then(response => resolve(response.data));
  });
};

export const fetchCityMunicipalities = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/city-municipality`).then(response => resolve(response.data));
  });
};

export const fetchCityMunicipalitiesWithCounty = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/city-municipality-with-county`).then(response => resolve(response.data));
  });
};

export const fetchCityMunicipalitiesAndCountiesForCase = async (idCase): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/city-municipality-and-county/case/${idCase}`).then(response => resolve(response.data));
  });
};

export const fetchZoningPlanTypes = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/zoning-plan-type`).then(response => resolve(response.data));
  });
};

export const fetchCommunities = async (idCityMunicipality: number | string | undefined): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/communities/${idCityMunicipality}`).then(response => resolve(response.data));
  });
};

export const fetchCommunitiesWithCityMunicipalitiesAndCounty = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/communities-with-cities-and-county`).then(response => resolve(response.data));
  });
};

export const fetchStreets = async (idCommunity: number | string | undefined): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/streets/${idCommunity}`).then(response => resolve(response.data));
  });
};

export const fetchHouseNumbers = async (idStreet: number | string | undefined): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/house-numbers/${idStreet}`).then(response => resolve(response.data));
  });
};

export const fetchCommunityPostalForCommunity = async (idCommunity: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios.get(`${codebookBaseUrl}/community-postal/${idCommunity}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
}

export const fetchCountyCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/county`).then(response => resolve(response.data));
  });
};

export const fetchResolutionTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/resolution-type`).then(response => resolve(response.data));
  });
};

export const fetchResolutionDeadlineCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/resolution-deadline`).then(response => resolve(response.data));
  });
};

export const fetchAppealSolutionFirstDegreeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/appeal-solution-first-degree`).then(response => resolve(response.data));
  });
};

export const fetchAppealSolutionSecondDegreeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/appeal-solution-second-degree`).then(response => resolve(response.data));
  });
};

export const fetchFormationCommitmentCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/formation-commitment`).then(response => resolve(response.data));
  });
};

export const fetchConnectionTrafficCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/connection-traffic`).then(response => resolve(response.data));
  });
};

export const fetchConnectionPowerGridCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/connection-power-grid`).then(response => resolve(response.data));
  });
};

export const fetchConnectionSewageCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/connection-sewage`).then(response => resolve(response.data));
  });
};

export const fetchExistingBuildingRatioCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/existing-building-ratio`).then(response => resolve(response.data));
  });
};

export const fetchApplicantsNumberCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/applicants-number`).then(response => resolve(response.data));
  });
};

export const fetchPartyNumberCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/party-number`).then(response => resolve(response.data));
  });
};

export const fetchPartyFileInsightCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/party-file-insight`).then(response => resolve(response.data));
  });
};

export const fetchProjectTypeCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/project-type`).then(result => resolve(result.data));
  });
};

export const fetchProjectTypeCodebookForCaseCategory = async (idCase: string): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/project-type/${idCase}`).then(result => resolve(result.data));
  });
};

export const fetchProjectMapCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/project-map`).then(result => resolve(result.data));
  });
};

export const fetchChambers = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/chambers`).then(result => resolve(result.data));
  });
};

export const fetchChamberMemberCodebook = async (): Promise<ChamberMemberCodebookModel[]> => {
  return await new Promise<ChamberMemberCodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/chamber-members`).then(result => resolve(result.data));
  });
};

export const fetchChamberMemberCodebookForChamber = async (idChamber: number): Promise<ChamberMemberCodebookModel[]> => {
  return await new Promise<ChamberMemberCodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/chamber-members/chamber/${idChamber}`).then(result => resolve(result.data))
  });
};

export const fetchChamberMemberCodebookForSiteSupervisor = async (): Promise<ChamberMemberCodebookModel[]> => {
  return await new Promise<ChamberMemberCodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/chamber-members-supervisor`).then(result => resolve(result.data));
  });
};

export const fetchCaseFunctionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-function`).then(response => resolve(response.data));
  });
};

export const fetchDeliveryMethodCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/delivery-method`).then(response => resolve(response.data));
  });
};

export const fetchEntryLetterDeliveryCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/entry-letter-delivery`).then(response => resolve(response.data));
  });
};

export const fetchConstructionBuildingProcedureTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/construction-building-procedure-type`).then(response => resolve(response.data));
  });
};

export const fetchBuildingPurposeCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-purpose`).then(result => resolve(result.data));
  });
};

export const fetchBuildingPurposeCodebookByType = async (type: number): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-purpose/${type}`).then(result => resolve(result.data));
  });
};

export const fetchRequirementGroupCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/requirement-group`).then(result => resolve(result.data));
  });
};

export const fetchBuildingPlacementCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-placement`).then(result => resolve(result.data));
  });
};

export const fetchBuildingFloorNumberTypeCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-floor-number-type`).then(result => resolve(result.data));
  });
};

export const fetchBuildingIndependentFunctionalNumberCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-independent-functional-number`).then(result => resolve(result.data));
  });
};

export const fetchConstructionCommencementCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/construction-commencement`).then(result => resolve(result.data));
  });
};

export const fetchBuildingTypeNationalClassificationCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-type-national-classification`).then(result => resolve(result.data));
  });
};

export const fetchBuildingTypeNationalClassificationCodebookForCBPType = async (idConstructionBuildingProcedureType: number): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-type-national-classification/${idConstructionBuildingProcedureType}`).then(result => resolve(result.data));
  });
};

export const fetchAccessibilityRatingCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/accessibility-rating`).then(result => resolve(result.data));
  });
};

export const fetchAccessibilityAppliedMeasureCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/accessibility-applied-measure`).then(result => resolve(result.data));
  });
};

export const fetchGreenInfrastructureTypeCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/green-infrastructure-type`).then(result => resolve(result.data));
  });
};

export const fetchEnergyCertificateMarkCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/energy-certificate-mark`).then(result => resolve(result.data));
  });
};

export const fetchConstructionBuildingProcedureByTypeCodebook = async (idCase: string, type: number): Promise<CodebookModel[]> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/codebooks/construction-building-procedure/${idCase}&${type}`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const fetchBuildingNumberCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/building-number`).then(result => resolve(result.data));
  });
};

export const fetchConstructionNumberCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/construction-number`).then(result => resolve(result.data));
  });
};

export const fetchProcedureNumberCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/procedure-number`).then(result => resolve(result.data));
  });
};

export const fetchPartyFeatureCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/party-feature`).then(response => resolve(response.data));
  });
};

export const fetchMainProjectTypeCodebookForCaseCategory = async (idCase: string): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/main-project-type/${idCase}`).then(result => resolve(result.data));
  });
};

export const fetchProjectTypeByVocationalDesignationCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/project-type-by-vocational-designation`).then(result => resolve(result.data));
  });
};

export const fetchProjectTypeByVocationalDesignationCodebookForCaseCategory = async (idCase: string): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/project-type-by-vocational-designation/${idCase}`).then(result => resolve(result.data));
  });
};

export const fetchRevisionTypeOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/revision-type`).then(response => resolve(response.data));
  });
};

export const fetchRevisionDeliveryOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/revision-delivery`).then(response => resolve(response.data));
  });
};

export const fetchReportTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/report-type`).then(response => resolve(response.data));
  });
};

export const fetchStatementTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/statement-type`).then(response => resolve(response.data));
  });
};

export const fetchWorkTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/work-type`).then(response => resolve(response.data));
  });
};

export const fetchConstructionFeeAmountOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/construction-fee-amount`).then(response => resolve(response.data));
  });
};

export const fetchSpecialFeeOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/special-fee`).then(response => resolve(response.data));
  });
};

export const fetchEstimatedConstructionCostOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/estimated-construction-cost`).then(response => resolve(response.data));
  });
};

export const fetchLawsuitSolutionOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/lawsuit-solution`).then(response => resolve(response.data));
  });
};

export const fetchNoticeBoardDeliveryOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/notice-board-delivery`).then(response => resolve(response.data));
  });
};

export const fetchPublicAuthorityOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/public-authority`).then(response => resolve(response.data));
  });
};

export const fetchPhaseConstructionTypeOptionsCodebook = async (): Promise<CodebookModel[]> => {
  return await new Promise<CodebookModel[]>((resolve, reject) => {
    axios.get(`api/codebooks/phase-construction-type`).then(result => resolve(result.data));
  });
};

export const fetchCasePublicAuthorityOptions = async (uuid: string): Promise<PublicAuthorityCodebook[]> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-public-authority/${uuid}`).then(response => resolve(response.data));
  });
};

export const fetchJptActivityOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/jpt-activity`).then(response => resolve(response.data));
  });
};

export const fetchLitigationOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/litigation`).then(response => resolve(response.data));
  });
};

export const fetchMethodOfApplicationOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/method-of-application`).then(response => resolve(response.data));
  });
};

export const fetchCadastralMunicipalities = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cadastral-municipality`).then(response => resolve(response.data));
  });
};

export const fetchTemplateCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/act-type`).then(response => resolve(response.data));
  });
};

export const fetchUrbanPlanObligation = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/urban-plan-obligation`).then(response => resolve(response.data));
  });
};

export const fetchZoningPlans = async (page: number, size: number, column: string, direction: string, payload: any): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${codebookBaseUrl}/zoning-plan/case/${payload.uuid}?page=${page}&size=${size}&column=${column}&direction=${direction}`, {
        countyIds: payload.countyIds,
        cityMunicipalityIds: payload.cityMunicipalityIds,
        zoningPlanTypeIds: payload.zoningPlanTypeIds,
      })
      .then(response => resolve(response.data));
  });
};

export const fetchCaseGroupCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-group`).then(response => resolve(response.data));
  });
};

export const fetchCaseCategoryForCaseGroup = async (caseGroups, isEdozvola = false, isEarhiva = false, isPublic = false): Promise<any> => {
  return await new Promise(resolve => {
    axios
      .post(`${codebookBaseUrl}/case-category/case-group?isEdozvola=${isEdozvola}&isEarhiva=${isEarhiva}&isPublic=${isPublic}`, caseGroups)
      .then(response => resolve(response.data));
  });
};

export const fetchAdministrativeUnitCodebookForPublicCaseCategory = async (caseCategories): Promise<any> => {
  return await new Promise(resolve => {
    axios.post(`${codebookBaseUrl}/administrative-unit/case-category`, caseCategories).then(response => resolve(response.data));
  });
};

export const fetchRequestWebIds = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/request-web-id`).then(response => resolve(response.data));
  });
};

export const fetchCaseCategoryOptions = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-category`).then(response => resolve(response.data));
  });
};

export const fetchCaseStatusForFilterCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-status/for-filter`).then(response => resolve(response.data));
  });
};

export const fetchCaseCategoryForFilterCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/case-category/for-filter`).then(response => resolve(response.data));
  });
};

export const fetchCmrBuildingPartCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-building-part`).then(response => resolve(response.data));
  });
};

export const fetchCmrSpecialBuildingPartCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-special-building-part`).then(response => resolve(response.data));
  });
};

export const fetchCmrSpaceTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-space-type`).then(response => resolve(response.data));
  });
};

export const fetchCmrFloorCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-floor`).then(response => resolve(response.data));
  });
};

export const fetchCmrFloorTypeCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-floor-type`).then(response => resolve(response.data));
  });
};

export const fetchCmrRoomCountCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-room-count`).then(response => resolve(response.data));
  });
};

export const fetchCmrLivingRoomCountCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-living-room-count`).then(response => resolve(response.data));
  });
};

export const fetchCmrKitchenCountCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-kitchen-count`).then(response => resolve(response.data));
  });
};

export const fetchCmrBathroomCountCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-bathroom-count`).then(response => resolve(response.data));
  });
};

export const fetchCmrSeparateToiletCountCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-separate-toilet-count`).then(response => resolve(response.data));
  });
};

export const fetchCmrDisabilityAdaptationCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-disability-adaptation`).then(response => resolve(response.data));
  });
};

export const fetchCmrElevatorAccessCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-elevator-access`).then(response => resolve(response.data));
  });
};

export const fetchCmrWaterSupplyConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-water-supply-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrSewageConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-sewage-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrElectricityConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-electricity-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrGasConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-gas-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrInternetConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-internet-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrHeatingConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-heating-connection`).then(response => resolve(response.data));
  });
};

export const fetchCmrHeatingEnergySourceCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-heating-energy-source`).then(response => resolve(response.data));
  });
};

export const fetchCmrCoolingConnectionCodebook = async (): Promise<any> => {
  return await new Promise(resolve => {
    axios.get(`${codebookBaseUrl}/cmr-cooling-connection`).then(response => resolve(response.data));
  });
};
